import { Routes } from '@angular/router';
import { LoginPageComponent } from './pages/login/login.page';
import { RegisterPageComponent } from './pages/register/register.page';
import { ForgotPasswordPageComponent } from './pages/forgot-password/forgot-password.page';
import { ResetPasswordPageComponent } from './pages/reset-password/reset-password.page';
import { LayoutComponent } from './layout/layout.component';
import { HomePageComponent } from './pages/home/home.page';
import { MePageComponent } from './pages/me/me.page';
import { HistoryPageComponent } from './pages/history/history.page';
import { AdminPlateauxPageComponent } from './pages/admin-plateaux/admin-plateaux.page';
import { AdminUsersPageComponent } from './pages/admin-users/admin-users.page';
import { AdminEmailsPageComponent } from './pages/admin-emails/admin-emails.page';
import { authGuard } from './core/auth.guard';
import { adminGuard } from './core/admin.guard';

export const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'register', component: RegisterPageComponent },
  { path: 'forgot-password', component: ForgotPasswordPageComponent },
  { path: 'reset-password', component: ResetPasswordPageComponent },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'home', component: HomePageComponent },
      { path: 'history', component: HistoryPageComponent },
      { path: 'me', component: MePageComponent },
      {
        path: 'admin',
        canActivate: [adminGuard],
        children: [
          { path: 'plateaux', component: AdminPlateauxPageComponent },
          { path: 'users', component: AdminUsersPageComponent },
          { path: 'emails', component: AdminEmailsPageComponent }
        ]
      },
      { path: '', pathMatch: 'full', redirectTo: 'home' }
    ]
  },
  { path: '**', redirectTo: 'home' }
];
